// lib
import fillArrayWithNumbers from '../../../../libs/fillArrayWithNumbers';

const convertIntervalToHours = (intervals) =>
  [...intervals]
    .map(([start, end]) => fillArrayWithNumbers(start, end - 1))
    .flat()
    .reduce(
      (hours, hour) => (hours.includes(hour) ? hours : [...hours, hour]),
      []
    )
    .sort((a, b) => a - b);

export default convertIntervalToHours;
